module.exports = __webpack_public_path__ + "img/balance-coin-low.f7c5f1b4.svg";